module.exports = __webpack_public_path__ + "img/hr.25d9e32.svg";